// CDN Module für das clientseitige Code Highlighting 
declare module 'https://esm.sh/shiki@1.29.2' {
    export function codeToHtml(code: string, options: { lang: string; theme: string }): Promise<string>;
}
declare module 'https://esm.sh/highlight.js@11.11.1/lib/common' {
    const hljs: { highlightAuto(code: string): { language: string } };
    export default hljs;
}

class Custom {

    public priceBase: number[] = [];

    constructor() {
        this.setOverlay();
        this.clickEvent();
        this.handleCustomNumberStepper();
        this.handleReloads();
        this.handleAutocomplete();
        this.handleUploadButton();
        this.handleFaqAccordion();
        this.bindSimplebimLiteAuthGateDownload();
        window.addEventListener("resize", () => {
            this.prepareSlider();
        });
        this.prepareSlider();
        this.bindTabs();
        this.bindLiteBurger();
        this.bindSimplebimLiteOrderHistoryScroll();
        this.bindSimplebimLiteDownloadButtonFeedback();
        this.handleBlogSearch();
        this.bindSubmitOnce();
        // Syntax Highlighting für Code Blöcke auf der Blogdetailseite
        this.initBlogCodeHighlighting();
    }

    /**
     * Syntax Highlighting für Code Blöcke auf der Blogdetailseite.
     * Die Bibliotheken werden nur geladen, wenn der Beitrag tatsächlich Code enthält
    */
    private async initBlogCodeHighlighting(): Promise<void> {
        // Snapshot der Code Blöcke, da wir die Elemente gleich ersetzen
        const blocks = Array.from(document.querySelectorAll('.blog-content pre.blog-code'));

        // Kein Code im Beitrag → gar nichts nachladen
        if (!blocks.length) {
            return;
        }

        // Bibliotheken erst bei Bedarf laden 
        const [{ codeToHtml }, { default: hljs }] = await Promise.all([
            import('https://esm.sh/shiki@1.29.2'),
            import('https://esm.sh/highlight.js@11.11.1/lib/common')
        ]);

        // highlight.js Sprach IDs auf Shiki IDs mappen 
        const langMap: Record<string, string> = {
            xml: 'html',
            plaintext: 'text',
            objectivec: 'objective-c',
            'php-template': 'php',
            'python-repl': 'python',
            vbnet: 'vb'
        };

        for (const pre of blocks) {
            const codeEl = pre.querySelector('code');
            if (!codeEl) {
                continue;
            }

            const source = codeEl.textContent ?? '';

            // Sprache automatisch erkennen
            const detected = hljs.highlightAuto(source).language;
            const lang = langMap[detected] || detected || 'text';

            let html: string;
            try {
                html = await codeToHtml(source, { lang, theme: 'dark-plus' });
            } catch {
                html = await codeToHtml(source, { lang: 'text', theme: 'dark-plus' });
            }

            pre.outerHTML = html;
        }
    }

    /**
     * Fügt die Tags beim Laden der Seite hinzu
     */
    private setOverlay() {

        const ove = document.createElement('div');
        ove.classList.add("open-overlay");
        ove.setAttribute("id", "openOverlay");
        document.body.appendChild(ove);

        const wrapper = document.createElement('div');
        wrapper.classList.add("wrapper-overlay");
        ove.appendChild(wrapper);

        const close = document.createElement('div');
        close.classList.add('close-overlay');
        close.onclick = () => this.deleteOverlay(undefined);
        wrapper.appendChild(close);

        const headline = document.createElement('div');
        headline.classList.add("headline-overlay");
        wrapper.appendChild(headline);

        const player = document.createElement('div');
        player.classList.add("player-overlay");
        wrapper.appendChild(player);

    }

    /**
     * Prüft und übergibt ein ClickEvent
     */
    private clickEvent() {
        const elementsNavbarToggler = document.getElementsByClassName('navbar-toggler');
        if (elementsNavbarToggler) {
            for (let index = 0; index < elementsNavbarToggler.length; index++) {
                const elem = elementsNavbarToggler[index];

                elem.addEventListener('click', () => this.toggleNavbar(<HTMLElement>elem));

            }
        }

        const dataove = document.querySelectorAll('[data-overlay]');
        if (!dataove) {
            return;
        }
        for (let i = 0; i < dataove.length; i++) {
            const element = dataove[i];
            element.addEventListener('click', () => {
                this.openOverlay(element as HTMLElement);
            });
        }

        /**
         * CheckoutType Auswahl
         */
        if (document.querySelector('#orderForm')) {
            const checkouttypeAll = document.querySelectorAll('[name="CheckoutType"]');
            for (let i = 0; i < checkouttypeAll.length; i++) {
                const element = checkouttypeAll[i];

                element.addEventListener("change", (e) => {
                    this.updateCheckoutType(e);
                });
            }
        }

        /**
         * Zahlungsarten Auswahl
         */
        if (document.querySelector('#orderForm')) {
            const billingDataBillingTypeAll = document.querySelectorAll('[name="BillingType"]');
            for (let i = 0; i < billingDataBillingTypeAll.length; i++) {
                const element = billingDataBillingTypeAll[i];

                element.addEventListener("change", (e) => {
                    this.updateBillingType(e);
                });
            }
        }
    }
    /**
     * öffnet das Overlay mit den Daten
     */
    private openOverlay(elem: HTMLElement) {
        let link = elem.getAttribute("data-target");
        if (!link) {

            return;

        }

        const actual = document.querySelector('.open-overlay');
        if (!actual) {
            return;
        }
        actual.classList.add("show");

        const addplayer = document.querySelector('.player-overlay');
        let player = document.createElement("div");
        player.classList.add("youtube-player");
        player.setAttribute("data-yt", link);
        player.setAttribute("title", elem.title);
        addplayer?.appendChild(player);

        const addheadline = document.querySelector('.headline-overlay');
        let headline = elem.getAttribute('title');
        if (headline) {
            const elemHeadline = document.createElement("div");
            elemHeadline.className = 'h2 title';
            elemHeadline.innerText = headline;

            addheadline?.appendChild(elemHeadline);
        }
    }

    /**
     * schließst das Overlay
     */
    private deleteOverlay(e?: MouseEvent) {


        const closeove = document.querySelector('.show');
        closeove?.classList.remove('show')

        const addheadline = document.querySelector('.headline-overlay')!;
        addheadline.innerHTML = "";

        const addplayer = document.querySelector('.player-overlay')!;
        addplayer.innerHTML = "";

    }

    /**
     * Öffnet/Schließt die Navigation in der mobilen Ansicht
     */
    public toggleNavbar(button: HTMLElement) {
        // aktuellen expanded-Zustand holen
        const isExpanded = button.getAttribute('data-expanded');

        const navBar = document.getElementById('nav1');
        if (!navBar) {
            return;
        }
        navBar.classList.toggle('expanded');
        navBar.removeAttribute('style');

        // data-expanded ändern
        button.setAttribute('data-expanded', (!isExpanded || isExpanded === 'false' ? 'true' : 'false'));
    }

    /**
     * Wenn Lastschrift checked ist, sollen zusätzliche Felder angezeigt werden
     * @param e 
     */
    public updateBillingType(e: Event): void {
        let target = <HTMLInputElement>e.target;
        const lastschriftOption = <HTMLElement>document.querySelector('#billingType');
        if ((target.value === "Sepa" && target.checked)) {
            lastschriftOption.hidden = false;
        }
        else {
            lastschriftOption.hidden = true;
        }
    }

    /**
     * Wenn Person checked ist, soll USt-ID verschwinden als Feld
     * @param e 
     */
    public updateCheckoutType(e: Event): void {
        let target = <HTMLInputElement>e.target;
        const checkoutOption = <HTMLElement>document.querySelector('#checkoutType');
        if ((target.value === "Person" && target.checked)) {
            checkoutOption.hidden = true;
        }
        else {
            checkoutOption.hidden = false;
        }
    }

    /**
    * Multipliziert den Preis mit der Anzahl der Lizenzen
    * @param ev 
    */
    public updatePrice(ev: Event): void {
        let qnt = parseInt((ev.currentTarget as HTMLInputElement).value);

        console.log('updatePrice', qnt);

        if (qnt < 1 || isNaN(qnt)) {
            (ev.currentTarget as HTMLInputElement).value = '1';
            qnt = 1;
        }

        const priceBaseAll = document.querySelectorAll('.priceBase');
        for (let i = 0; i < priceBaseAll.length; i++) {
            const element = priceBaseAll[i];
            const priceNetto = parseFloat((element.getAttribute('data-pnetto') || '').replace('.', '').replace(' ', '').replace(',', '.')) ?? 0;
            const priceBrutto = parseFloat((element.getAttribute('data-pbrutto') || '').replace('.', '').replace(' ', '').replace(',', '.')) ?? 0;
            const priceVat = parseFloat((element.getAttribute('data-pvat') || '').replace('.', '').replace(' ', '').replace(',', '.')) ?? 0;

            console.log(priceNetto, priceBrutto, priceVat);

            let finalPrice: number;

            if (!isNaN(priceNetto)) {
                finalPrice = priceNetto * qnt;
            } else if (!isNaN(priceBrutto)) {
                finalPrice = priceBrutto * qnt;
            } else if (!isNaN(priceVat)) {
                finalPrice = priceVat * qnt;
            } else {
                finalPrice = this.priceBase[element.id] * qnt;
            }

            const formattedPrice = new Intl.NumberFormat('de-DE', { maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(finalPrice) + " €";
            element.innerHTML = formattedPrice;
        }
    }

    /**
     * Fängt die Klicks des Custom-Number-Steppers ab und zählt entsprechend im Input hoch/runter
     */
    private handleCustomNumberStepper(): void {
        var buttons = document.querySelectorAll('form .custom-number-stepper');
        for (let i = 0; i < buttons.length; i++) {
            const button = buttons[i];
            button.addEventListener('click', function (e) {
                e.preventDefault();

                const elem = buttons[i].classList;
                if (elem == null) {
                    return;
                }

                let input: HTMLInputElement;
                let add = 0;

                if (elem.contains('up')) {
                    // Hochzählen
                    // Input Element suchen
                    const prevElem = (<HTMLElement>e.target).previousElementSibling;
                    if (prevElem == null) {
                        return;
                    }
                    input = <HTMLInputElement>prevElem;
                    add = 1;

                } else if (elem.contains('down')) {
                    // Runterzählen
                    // Input Element suchen
                    const nextElem = (<HTMLElement>e.target).nextElementSibling;
                    if (nextElem == null) {
                        return;
                    }
                    input = <HTMLInputElement>nextElem;
                    add = -1;
                } else {
                    return;
                }

                if (input == null) {
                    return;
                }

                let inputmin = Number(input.min)
                const val = Number(input.value);
                let result = (isNaN(val) ? inputmin : val) + add;
                if (result < inputmin) {
                    result = inputmin;
                }
                input.value = result.toString();

                input.dispatchEvent(new Event('input'));

                if (input.previousElementSibling) {
                    if (result == inputmin) {
                        input.previousElementSibling.classList.add('disabled');
                    } else {
                        input.previousElementSibling.classList.remove('disabled');
                    }
                }
            });
        }
    }

    /**
     * Setzt EventListener auf Elemente, deren Seite nach Änderung neu geladen werden müssen
     */
    private handleReloads(): void {
        const elementsReloadOnChange = document.getElementsByClassName('reload-on-change');
        const idString = document.querySelector('form')?.dataset.reloadid;

        if (!idString) 
        {
            return;
        }

        const elementOrderForm = document.getElementById(idString);

        if (!elementsReloadOnChange || !elementOrderForm) 
        {
            return;
        }

        for (let i = 0; i < elementsReloadOnChange.length; i++) {
            const element = <HTMLFormElement>elementsReloadOnChange[i];

            element.addEventListener('change', () => {
                element.form.action = location.pathname + '#' + idString;
                element.form.submit();
            });
        }
    }

    /** Prüft auf Input-Autocompletes und filtert die Liste bei der Suche */
    private handleAutocomplete(): void {
        const autocompleteAreas = document.querySelectorAll('.autocomplete-area');
        if (!autocompleteAreas.length) {
            return;
        }

        for (let j = 0; j < autocompleteAreas.length; j++) {
            const area = autocompleteAreas[j];

            // Ziel-Input (hidden)
            const inputAim = <HTMLInputElement>area.querySelector('.autocomplete-input-aim');
            // Such-Input
            const inputSearch = <HTMLInputElement>area.querySelector('.autocomplete-input-search');
            if (!inputAim || !inputSearch) {
                return;
            }

            // Alle Optionen
            const listOptions = area.querySelectorAll('[data-autocomplete-key]');

            // Click außerhalb der Liste schließt ebendiese
            document.addEventListener('click', (ev: MouseEvent) => {
                const isClickOutsideElement = (<HTMLDivElement>ev.target).contains(area);
                if (isClickOutsideElement) {
                    if (!inputAim.value) {
                        // Wenn keine Auswahl getroffen wurde, dann Feld leeren
                        inputSearch.value = '';
                    } else {
                        // Auflistung nach Key durchsuchen um zu verifizieren, dass das richtige Value ausgegeben wird
                        for (let i = 0; i < listOptions.length; i++) {
                            const element = listOptions[i];
                            if (element.getAttribute('data-autocomplete-key') == inputAim.value) {
                                inputSearch.value = element.getAttribute('data-autocomplete-value') || '';
                            }
                        }

                        // Wenn kein Value für den hinterlegten Key gefunden wurde, dann Feld leeren
                        if (!inputSearch.value) {
                            inputAim.value = '';
                        }
                    }

                    area.querySelector('.autocomplete-items')?.classList.remove('open');
                }
            });


            if (!listOptions.length) {
                return;
            }
            for (let i = 0; i < listOptions.length; i++) {
                const element = <HTMLDivElement>listOptions[i];
                element.addEventListener('click', () => {
                    const val = element.getAttribute('data-autocomplete-key');
                    inputAim.value = val || '';
                    inputSearch.value = element.innerText;

                    area.querySelector('.autocomplete-items')?.classList.remove('open');
                });

            }

            // Input Suche - Click Event
            inputSearch.addEventListener('click', (ev: MouseEvent) => {
                area.querySelector('.autocomplete-items')?.classList.add('open');
            });

            // Default Option, wenn kein Treffer gefunden wurde
            const defaultOption = <HTMLDivElement>area.querySelector('.option.default');
            if (defaultOption) {
                defaultOption.addEventListener('click', () => {
                    inputAim.value = '-1';
                    inputSearch.value = defaultOption.innerText;

                    area.querySelector('.autocomplete-items')?.classList.remove('open');
                });
            }

            // Input Suche - Keyup Event
            inputSearch.addEventListener('keyup', (ev: KeyboardEvent) => {

                if (!listOptions.length) {
                    return;
                }
                const inputAC = <HTMLInputElement>inputSearch;
                const searchString = inputAC.value.toLowerCase();
                const searchStringLength = searchString.length;

                // Sichtbarkeit Optionen
                for (let i = 0; i < listOptions.length; i++) {
                    const optionElement = <HTMLElement>listOptions[i];
                    const optionValue = optionElement.innerText;

                    // Zusatz Filterinformationen (bspw. College: Stadt)
                    const optionValueAddition = optionElement.getAttribute('data-autocomplete-additionalValue');

                    const foundInValueAddition = optionValueAddition && optionValueAddition.toLowerCase().indexOf(searchString) >= 0;

                    const idxStart = optionValue.toLowerCase().indexOf(searchString);
                    if ((idxStart < 0 && foundInValueAddition === false) || !inputAC.value.length) {
                        // -> Suchstring nicht gefunden
                        if (!inputAC.value.length) {
                            // Leerer Suchstring
                            optionElement.classList.remove('hidden');
                        } else {
                            // Klasse 'hidden' setzen
                            optionElement.classList.add('hidden');
                        }
                        optionElement.classList.remove('hit');
                        // Plain-Text setzen
                        optionElement.innerText = optionValue;
                    } else {
                        // -> Suchstring gefunden

                        // Klasse 'hidden' entfernen
                        optionElement.classList.remove('hidden');
                        optionElement.classList.add('hit');

                        const stringOriginal = optionValue.substring(idxStart, idxStart + searchStringLength);

                        // Text vor dem Suchstring
                        let textHighlighted = '';

                        // Nur highlighten, wenn der Suchstring im Value vorkommt -> wenn er nur in ValueAdditional vorkommt, dann kein Highlighting
                        if (idxStart >= 0) {
                            if (idxStart > 0) {
                                textHighlighted += optionValue.substring(0, idxStart);
                            }

                            // Suchstring (hervorgehoben)
                            textHighlighted += '<b>' + stringOriginal + '</b>';

                            // Text nach dem Suchstring
                            textHighlighted += optionValue.substring(idxStart + searchString.length);
                        }

                        // HTML-Text setzen
                        optionElement.innerHTML = textHighlighted || optionValue;
                    }
                }

                // Prüfen, ob überhaupt ein Treffer da ist
                const anyHits = area.querySelectorAll('[data-autocomplete-value].hit');
                if (defaultOption) {
                    if (!anyHits?.length) {
                        // Keine Treffer -> Sonstiges
                        defaultOption.classList.add('show');
                    } else {
                        // Treffer -> kein Default
                        defaultOption.classList.remove('show');
                    }
                }


                // Sichtbarkeit Option-Groups
                const listOptionGroup = area.getElementsByClassName('option-group');
                if (!listOptionGroup) {
                    return;
                }
                for (let i = 0; i < listOptionGroup.length; i++) {
                    const element = listOptionGroup[i];
                    const resultsHit = element.querySelectorAll('[data-autocomplete-value].hit');

                    if (!resultsHit.length && inputAC.value.length) {
                        element.classList.add('hidden');
                    } else {
                        element.classList.remove('hidden');
                    }

                }
            })

        }
    }

    /**
     * Setzt EventListener auf Input Element und ändert den Dateinamen ab
     * Aktuell nur im Education Bereich für das Upload Feld
     */
    private handleUploadButton(): void {
        // Alle Upload-Container abrufen
        const uploadContainers = document.querySelectorAll(".upload");

        // Prüft, on Elemente gefunden wurden
        if (!uploadContainers.length) {
            return;
        }

        uploadContainers.forEach(container => {
            // Änderungsereignis für jedes Input-Element innerhalb des Containers hinzufügen
            const inputTypeFile = container.querySelector("input[type=file]") as HTMLInputElement | null;
            const uploadText = container.querySelector(".input") as HTMLElement | null;
            if (inputTypeFile && uploadText) {
                inputTypeFile.addEventListener("change", (e: Event) => {
                    const target = e.target as HTMLInputElement;
                    // Dateiname anzeigen (ohne "fakepath")
                    uploadText.innerText = target.value.replace(/C:\\fakepath\\/i, '');
                });
            }
        });
    }

    /**
     * FAQ Accordion Toggle Funktionalität
     * Zusammengeführt aus ehemals getrenntem faq.ts:
     * Setzt .open auf .faq-item und .faq-answer; max-height wird per scrollHeight gesteuert.
     */
    private handleFaqAccordion(): void {
        const faqItems = document.querySelectorAll<HTMLElement>('.faq-item');
        const answerSpacer = 25; // Platz für Padding/Margin

        faqItems.forEach(item => {
            const question = item.querySelector<HTMLElement>('.faq-question');
            const answer = item.querySelector<HTMLElement>('.faq-answer');
            if (!question || !answer) return;

            question.addEventListener('click', () => {
                const isOpen = item.classList.contains('open');

                if (isOpen) {
                    item.classList.remove('open');
                    answer.classList.remove('open');
                    answer.style.maxHeight = '0px';
                } else {
                    item.classList.add('open');
                    answer.classList.add('open');
                    requestAnimationFrame(() => {
                        answer.style.maxHeight = (answer.scrollHeight + answerSpacer) + 'px';
                    });
                }
            });
        });
    }

    /**Slider vorbereiten */
    private prepareSlider(restartInterval = false): void {
        const sliders = document.querySelectorAll('.slider-outer');
        const width = document.body.clientWidth;

        const xsMax = 767;
        const smMax = 991;
        const mdMax = 1199;
        for (let i = 0; i < sliders.length; i++) {
            const currentSlider = sliders[i];

            if (!currentSlider) {
                continue;
            }

            // Ändert die Anzahl der Elemente pro Slide entsprechend der Fensterbreite
            const originalItemsPerSlide = parseInt((currentSlider.getAttribute('data-itemso') || '1'), 10);
            let itemsPerSlide = 1;
            if (originalItemsPerSlide > 1) {
                if (width <= xsMax) {
                    itemsPerSlide = 1;
                }
                // else if (width <= smMax) {
                //     itemsPerSlide = 2;
                // } else if (width <= mdMax) {
                //     if (originalItemsPerSlide > 3) {
                //         itemsPerSlide = 3;
                //     } 
                // } 
                else {
                    itemsPerSlide = originalItemsPerSlide;
                }
            }
            if (!itemsPerSlide)
            {
                itemsPerSlide = originalItemsPerSlide;
            }

            currentSlider.setAttribute('data-items', itemsPerSlide.toString());

            // Indikatoren ggf. anpassen
            const sliderItems = currentSlider.querySelectorAll('.slider-inner > .item');
            const countItems = sliderItems.length;
            const countNeededIndicators = itemsPerSlide > 1 ? Math.ceil(countItems / itemsPerSlide) : countItems;
            const countIndicators = document.querySelectorAll('.indicator-area[data-slider-id="' + currentSlider.id + '"] > .indicator').length;
            if (countNeededIndicators != countIndicators) {
                const indicatorArea = document.querySelector('.indicator-area[data-slider-id="' + currentSlider.id + '"]');
                if (indicatorArea) {
                    indicatorArea.innerHTML = '';
                    for (let j = 0; j < countNeededIndicators; j++) {
                        const elem = document.createElement('div');
                        elem.classList.add('indicator');
                        if (j === 0) {
                            elem.classList.add('active');
                        }
                        elem.setAttribute('data-slide-to', j.toString());
                        elem.setAttribute('data-slider-id', currentSlider.id);

                        indicatorArea.appendChild(elem);
                    }
                }
            }

            // Bei Resize wird der Slider neu gestartet
            if (restartInterval)
            {
                //Intervall stoppen
                const dtIntrvlNm = currentSlider.getAttribute('data-interval-name');
                if (dtIntrvlNm) {
                    clearInterval(parseInt(dtIntrvlNm, 10));
                }

                // Alle Werte zurücksetzen
                currentSlider.setAttribute('data-active-index', '0');
                (<HTMLElement>currentSlider.querySelector('.slider-inner')).style.transform = 'translate3d(0, 0, 0)';

                // Die ersten Slider-Elemente auf aktiv setzen
                for (let k = 0; k < sliderItems.length; k++) {
                    const child = sliderItems[k];

                    if (k < itemsPerSlide && child.classList.contains('active') === false) {
                        child.classList.add('active');
                    } else {
                        child.classList.remove('active');
                    }
                }
            }

            // Steuerung per Interval
            this.startSliderInterval(currentSlider);
        }

        // Steuerung per Indicator
        const sliderIndicators = document.querySelectorAll('.indicator-area');
        for (let i = 0; i < sliderIndicators.length; i++) {
            const indicatorArea = sliderIndicators[i];
            const childrenIndicators = indicatorArea.querySelectorAll('.indicator');

            for (let j = 0; j < childrenIndicators.length; j++) {
                const singleIndicator = childrenIndicators[j];

                singleIndicator.addEventListener('click', (ev) => this.slideByIndicators(ev, <HTMLElement>indicatorArea, <HTMLElement>singleIndicator));
            }

        }
    }

    /** Startet den Slider Interval */
    private startSliderInterval(sliderInterval): void {
        const interval = parseInt(sliderInterval.getAttribute('data-interval'), 10);
        if (isNaN(interval)) {
            return;
        }

        const intervalId = setInterval(() => {
            this.slideByInterval(sliderInterval);

        }, interval);

        sliderInterval.setAttribute('data-interval-name', intervalId);
    }

    /**
     * Auto on Interval
     * @param sliderElement 
     * @returns 
     */
    private slideByInterval(sliderElement: HTMLElement): void {
        const sliderItems = sliderElement.querySelectorAll('.slider-inner > .item');
        const itemsPerSlide = parseInt(sliderElement?.getAttribute('data-items') || '1', 10);

        if (!sliderItems || !itemsPerSlide || sliderItems.length <= itemsPerSlide) {
            return;
        }

        let lastActiveIndex = parseInt(sliderElement.getAttribute('data-active-index') || '0', 10);
        const countElements = sliderElement.querySelectorAll('.slider-inner > .item').length;
        let activeIndex = 1;

        // Holt den Abstand zwischen den einzelnen Items zur Berechnung
        let space = 0;
        const singleItem = <HTMLElement>sliderItems[0];
        const singleMarginRight = window.getComputedStyle(singleItem).marginRight;
        if (singleMarginRight) {
            space = parseInt(singleMarginRight, 10);
        }

        if (!isNaN(lastActiveIndex)) {
            if (lastActiveIndex === countElements - itemsPerSlide) {
                activeIndex = 0
            }
            else {
                activeIndex = lastActiveIndex + 1;
            }

            if (activeIndex > sliderItems.length - itemsPerSlide) {
                activeIndex = 0;
            }
        } else {
            lastActiveIndex = 0;
        }
        sliderElement.setAttribute('data-active-index', activeIndex.toString());

        let width = 0;
        for (let i = 0; i < sliderItems.length; i++) {
            var newWidth = sliderItems[i].clientWidth + (itemsPerSlide > 1 ? space : 0);
            if (i > 0 && i <= activeIndex) {
                width += newWidth;
            }
            if (i === lastActiveIndex) {
                sliderItems[i].classList.remove('active');
            }
            if (i >= activeIndex && i < sliderItems.length && i < (activeIndex + itemsPerSlide)) {
                sliderItems[i].classList.add('active');
            }
        }

        const sliderInner = sliderElement.querySelector('.slider-inner');
        (<HTMLElement>sliderInner).style.transform = 'translate3d(-' + width + 'px, 0, 0)';

        // Indicatoren setzen
        const indicators = document.querySelectorAll('.indicator-area .indicator[data-slider-id="' + sliderElement.id + '"]');
        const currentActiveIndicator = activeIndex > 0 ? Math.floor((activeIndex + (itemsPerSlide - 1)) / itemsPerSlide) : 0;
        for (let i = 0; i < indicators.length; i++) {
            const singleIndicator = indicators[i];
            if (i === currentActiveIndicator) {
                singleIndicator.classList.add('active');
            } else {
                singleIndicator.classList.remove('active');
            }

        }
    }

    /**
     * Click on Indicator
     * @param ev 
     * @param indicatorArea 
     * @param singleIndicator 
     */
    private slideByIndicators(ev, indicatorArea: HTMLElement, singleIndicator: HTMLElement): void {
        const nextIndex = parseInt(singleIndicator?.getAttribute('data-slide-to') || '0', 10);
        const dtsldId = singleIndicator.getAttribute('data-slider-id');
        if (!dtsldId) {
            return;
        }
        const slider = document.getElementById(dtsldId);
        if (!slider) {
            return;
        }
        const itemsPerSlide = parseInt(slider.getAttribute('data-items') || '1', 10);

        // Interval stoppen, falls vorhanden
        const dataIntervalName = 'data-interval-name';
        let restartInterval = false;
        if (slider.getAttribute(dataIntervalName)) {
            const dtaIntrvlNme = slider.getAttribute(dataIntervalName);
            if (dtaIntrvlNme) {
                clearInterval(parseInt(dtaIntrvlNme, 10));
                slider.removeAttribute(dataIntervalName);
            }

            restartInterval = true;
        }

        const list = indicatorArea.children;
        for (var i = 0; i < list.length; i++) {
            list[i].classList.remove('active');
        }
        singleIndicator.classList.add('active');

        const slides = slider.querySelectorAll('.slider-inner > .item');
        // var lastActive;
        let nextActive: HTMLElement;
        for (var i = 0; i < slides.length; i++) {
            if (slides[i].classList.contains('active')) {
                // lastActive = slides[i];
                slides[i].classList.remove('active');
            }
            if (i === nextIndex) {
                nextActive = <HTMLElement>slides[i];
            }
        }

        const sliderInner = slider.querySelector('.slider-inner');
        if (!sliderInner) {
            return;
        }

        let widthVal: number;
        // Anzahl der übrigen Elemente
        var rest = slides.length - (itemsPerSlide * nextIndex);
        let start: number;
        let end: number;

        // Holt den Abstand zwischen den einzelnen Items zur Berechnung
        let space = 0;
        const singleItem = <HTMLElement>sliderInner.children[0];
        const singleMarginRight = window.getComputedStyle(singleItem).marginRight;
        if (singleMarginRight) {
            space = parseInt(singleMarginRight, 10);
        }

        if ((nextIndex + 1) === (Math.ceil(slides.length / itemsPerSlide)) && rest !== itemsPerSlide) {
            const widthLeftover = ((sliderInner.clientWidth - (space * (itemsPerSlide - 1))) / itemsPerSlide + space) * rest;
            const lastIndex = nextIndex - 1;

            // Bisheriger Wert
            widthVal = sliderInner.clientWidth * lastIndex + (itemsPerSlide > 1 ? (space * lastIndex) : 0);
            // + Restwert der einzelnen Elemente
            widthVal += widthLeftover;

            start = slides.length - 1 - rest;
            end = slides.length - 1;
        } else {
            widthVal = nextIndex === 0 ? 0 : sliderInner.clientWidth * nextIndex + (itemsPerSlide > 1 ? (space * nextIndex) : 0);

            start = nextIndex * itemsPerSlide;
            end = start + (itemsPerSlide - 1)
        }

        // Neue aktive setzen
        let startActive = start;
        while (startActive <= end) {
            slides[startActive].classList.add('active');
            startActive++;
        }

        (<HTMLElement>sliderInner).style.transform = 'translate3d(-' + widthVal + 'px, 0, 0)';

        if (restartInterval) {
            const dtntrvl = slider.getAttribute('data-inverval');
            if (dtntrvl) {
                const interval = parseInt(dtntrvl, 10);
                slider.setAttribute('data-active-index', start.toString())

                // Interval neu starten
                setTimeout(() => {
                    custom.startSliderInterval(slider);
                }, interval);
            }
        }
    }

    /**
     * Für Simplebim Lite: Auth Panel oben im Header mit Tabs für Login/Registrierung/Passwort vergessen
     * Schaltet die Header-Tabs im Auth-Panel und zeigt die passende Pane an.
     */
    private bindTabs(): void {
        const tabs = Array.from(document.querySelectorAll('.sbl-auth-tab')) as HTMLButtonElement[];
        if (!tabs.length) {
            return;
        }

        const panes = Array.from(document.querySelectorAll('.sbl-auth-pane')) as HTMLElement[];
        const tabGroup = document.querySelector('.sbl-auth-tabs') as HTMLElement | null;
        const authPanel = document.querySelector('.sbl-auth-panel') as HTMLElement | null;

        const activeTab = tabs.find((tab) => tab.classList.contains('is-active'));
        if (activeTab) {
            const initialTarget = activeTab.getAttribute('data-sbl-auth-tab');
            if (initialTarget) {
                tabGroup?.setAttribute('data-active-tab', initialTarget);
                authPanel?.setAttribute('data-active-tab', initialTarget);
            }
        }

        tabs.forEach((tab) => {
            tab.addEventListener('click', () => {
                const target = tab.getAttribute('data-sbl-auth-tab');

                tabs.forEach((candidate) => {
                    const isActive = candidate === tab;
                    candidate.classList.toggle('is-active', isActive);
                    candidate.setAttribute('aria-selected', isActive ? 'true' : 'false');
                });

                panes.forEach((pane) => {
                    pane.classList.toggle('is-active', pane.getAttribute('data-sbl-auth-pane') === target);
                });

                if (target) {
                    tabGroup?.setAttribute('data-active-tab', target);
                    authPanel?.setAttribute('data-active-tab', target);
                }
            });
        });

        return;
    }

    /**
     * Für Simplebim Lite: Burger-Menü im Header (mobile) öffnen und schließen.
     * @returns void
     */
    private bindLiteBurger(): void {
        const toggle = document.querySelector('.sbl-burger-toggle') as HTMLButtonElement | null;
        const group = document.querySelector('.sbl-right-group') as HTMLElement | null;
        if (!toggle || !group) {
            return;
        }

        toggle.addEventListener('click', (e) => {
            e.stopPropagation();
            const isExpanded = group.getAttribute('data-expanded') === 'true';
            group.setAttribute('data-expanded', isExpanded ? 'false' : 'true');
            toggle.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
        });

        document.addEventListener('click', (e) => {
            if (!group.contains(e.target as Node)) {
                group.setAttribute('data-expanded', 'false');
                toggle.setAttribute('aria-expanded', 'false');
            }
        });

        return;
    }

    /**
     * Für Simplebim Lite Auth-Gate: Download in verstecktem Iframe starten
     * und danach die Erfolgsansicht (Icon + Heading) einblenden.
     * @returns void
     */
    private bindSimplebimLiteAuthGateDownload(): void {
        const downloadLink = document.getElementById('sbl-auth-gate-download-link') as HTMLAnchorElement | null;
        if (!downloadLink) {
            return;
        }

        const readyBlock = document.getElementById('sbl-auth-gate-ready');
        const downloadedBlock = document.getElementById('sbl-auth-gate-downloaded');
        const downloadActionWrap = document.getElementById('sbl-auth-gate-download-action');
        const loginRequiredHeading = document.getElementById('sbl-auth-gate-login-required');
        let switched = false;

        const switchToDownloadedState = (): void => {
            if (switched) {
                return;
            }

            switched = true;
            readyBlock?.classList.add('hidden');
            downloadedBlock?.classList.remove('hidden');
            // Gesamten Button-Container ausblenden, damit keine leere Margin-Fläche das Layout verschiebt.
            downloadActionWrap?.classList.add('hidden');
            loginRequiredHeading?.classList.add('hidden');
            downloadLink.classList.add('hidden');
        };

        // Öffnet den Download in einem neuen Tab (nutzerinitiiert) und zeigt direkt die Erfolgs-UI an.
        downloadLink.addEventListener('click', (event: MouseEvent) => {
            event.preventDefault();

            // Nutzerinitiiertes neues Tab/Window; sehr kompatibel für Downloads
            try {
                window.open(downloadLink.href, '_blank');
            } 
            catch {
                // Falls popup-blocked, versuchen wir das Href als Fallback zu navigieren
                window.location.href = downloadLink.href;
            }

            // Sofort UI auf Erfolg setzen (kein zuverlässiger Abschluss-Indikator erforderlich)
            switchToDownloadedState();
        });
    }

    /** 
     * Für Simplebim Lite: Im Downloadverlauf den Verlauf-Container scrollen und einen Fade-Effekt am unteren Rand einblenden, wenn nicht am Ende der Liste.
     * @returns void
     */
    private bindSimplebimLiteOrderHistoryScroll(): void
    {
        const scroll = document.getElementById('sbl-history-scroll');
        const fade = document.getElementById('sbl-history-fade');
        if (!scroll || !fade) return;
        function update() {
            const atBottom = scroll.scrollTop + scroll.clientHeight >= scroll.scrollHeight - 8;
            fade.style.opacity = atBottom ? '0' : '1';
        }
        scroll.addEventListener('scroll', update, { passive: true });
        update();
    };

    /**
     * Für Simplebim Lite: Klick-Feedback beim Download in der Historie.
     * Zeigt eine kurze Animation auf dem betroffenen Listeneintrag an.
     * @returns void
     */
    private bindSimplebimLiteDownloadButtonFeedback(): void
    {
        const links = document.querySelectorAll<HTMLAnchorElement>('#sbl-history-scroll .sbl-history-item-action a.button--small');
        if (!links.length) {
            return;
        }

        const downloadingClass = 'sbl-history-item--downloading';
        const downloadedClass = 'sbl-history-item--downloaded';

        links.forEach((link) => {
            link.addEventListener('click', () => {
                const historyItem = link.closest('.sbl-history-item') as HTMLElement | null;
                if (!historyItem || historyItem.classList.contains('sbl-history-item--expired')) {
                    return;
                }

                historyItem.classList.remove(downloadingClass, downloadedClass);
                void historyItem.offsetWidth;
                historyItem.classList.add(downloadingClass);

                window.setTimeout(() => {
                    historyItem.classList.remove(downloadingClass);
                    historyItem.classList.add(downloadedClass);

                    window.setTimeout(() => {
                        historyItem.classList.remove(downloadedClass);
                    }, 1400);
                }, 220);
            });
        });
    }
    
    
    /**
     * client-seitige Blog-Suche.
    */
    private handleBlogSearch(): void {
        const input = document.getElementById('blog-search-input') as HTMLInputElement | null;

        // Kein Suchfeld im DOM → nicht auf Blog-Seite, früh abbrechen
        if (!input){
            return;
        }

        // Alle Blogs einmalig cachen — ändern sich nach dem Seitenaufruf nicht mehr
        const posts         = Array.from(document.querySelectorAll<HTMLElement>('.blog-container > a'));
        const banner        = document.getElementById('blog-search-banner');
        const infoText      = document.getElementById('blog-search-info-text');
        const resetLink     = document.getElementById('blog-search-reset');
        const noResults     = document.getElementById('blog-no-results');
        const noResultsText = document.getElementById('blog-no-results-text');

        // Kategorie Filter Buttons cachen aktive ids im Set führen
        const categoryButtons  = Array.from(document.querySelectorAll<HTMLButtonElement>('.blog-category-btn'));
        const selectedCategories = new Set<string>();

        // Debounce-Timer: wird bei jedem Tastendruck zurückgesetzt
        let timer: ReturnType<typeof setTimeout>;

        /**
         * XSS-Schutz: Konvertiert Nutzereingabe in sicheren HTML-String.
         * Sonderzeichen wie <, >, " werden escaped — nie direkt als innerHTML nutzen.
        */
        const escapeHtml = (text: string): string => {
            const div = document.createElement('div');
            div.appendChild(document.createTextNode(text));
            return div.innerHTML;
        };

        /**
         * Kernfunktion: Filtert alle Posts anhand des Suchbegriffs.
         *
         * @param rawTerm - Originaleingabe des Nutzers (für Anzeige im Banner)
         *                  Leerer String = kein Filter, alle Posts sichtbar
         */
        const applyFilter = (rawTerm: string): void => {
            // Lowercase nur für den Vergleich — Originalschreibweise für Anzeige behalten
            const term = rawTerm.toLowerCase();
            let visibleCount = 0;

            // Jeden Post gegen Suchbegriff und Kategoriefilter prüfen
            posts.forEach(post => {
                const searchHit =
                    !term ||                                          // kein Suchbegriff → immer treffer
                    post.dataset.searchTitle?.includes(term)  ||     // Titel
                    post.dataset.searchDesc?.includes(term)   ||     // Kurzbeschreibung
                    post.dataset.searchAuthor?.includes(term) ||     // Autor
                    post.dataset.searchDate?.includes(term);         // Datum (dd.MM.yyyy)
                
                const postCategories = post.dataset.searchCategories
                    ? post.dataset.searchCategories.split(',')
                    : [];
                const categoryHit =
                    selectedCategories.size === 0 ||
                    postCategories.some(id => selectedCategories.has(id));

                const hit = searchHit && categoryHit;

                post.style.display = hit ? '' : 'none';
                if (hit) {
                    visibleCount++;
                }
            });

            // Ein Filter ist aktiv, wenn ein Suchbegriff vorliegt oder Kategorien gewählt sind
            const filterActive = !!rawTerm || selectedCategories.size > 0;

            // Banner ein-/ausblenden und Suchbegriff anzeigen
            if (banner) {
                banner.style.display = rawTerm ? '' : 'none';
            }

            if (infoText) {
                infoText.innerHTML = rawTerm
                    ? `Posts für die Suchanfrage <strong>"${escapeHtml(rawTerm)}"</strong> werden angezeigt.`
                    : '';
            }
            
            if (resetLink) {
                resetLink.style.display = rawTerm ? '' : 'none';
            }

             // No Results einblenden, wenn ein Filter (Suche oder Kategorie) aktiv ist und kein Treffer
            if (noResults) {
                noResults.style.display = (filterActive && visibleCount === 0) ? '' : 'none';
            }

            if (noResultsText && filterActive && visibleCount === 0) {
                noResultsText.innerHTML = rawTerm
                    ? `Keine Artikel für „<em>${escapeHtml(rawTerm)}</em>" gefunden.`
                    : 'Keine Artikel in den gewählten Kategorien gefunden.';
            }

            // URL synchronisieren ohne Seitenreload — ermöglicht Teilen des Suchergebnisses
            const url = new URL(window.location.href);
            rawTerm ? url.searchParams.set('q', rawTerm) : url.searchParams.delete('q');
            history.replaceState(null, '', url.toString());
        };

        // Shareable URL: ?q= beim Seitenaufruf sofort anwenden (z.B. geteilter Link)
        const initialTerm = new URLSearchParams(window.location.search).get('q')?.trim() ?? '';
        if (initialTerm) {
            input.value = initialTerm;
            applyFilter(initialTerm);
        }

        // Live-Filter mit 250ms Debounce — verhindert Filter-Aufruf bei jedem Tastendruck
        input.addEventListener('input', () => {
            clearTimeout(timer);
            timer = setTimeout(() => applyFilter(input.value.trim()), 250);
        });

        // Filter Buttons Auswahl toggeln und Filter neu anwenden
        categoryButtons.forEach(btn => {
            btn.addEventListener('click', () => {
                const id = btn.dataset.categoryId;
                if (!id) {
                    return;
                }

                if (selectedCategories.has(id)) {
                    selectedCategories.delete(id);
                    btn.classList.remove('active');
                } else {
                    selectedCategories.add(id);
                    btn.classList.add('active');
                }

                applyFilter(input.value.trim());
            });
        });
    }

    /**
     * Prevents duplicate form submissions by disabling all submit buttons after a valid form submit.
     * The disabled state resets automatically on page reload (triggered by the server response).
     * Only applies to forms that do not carry the `data-submit-once="false"` attribute.
     */
    private bindSubmitOnce(): void {
        document.addEventListener('submit', (e: Event) => {
            const form = e.target as HTMLFormElement;
            if (form.dataset.submitOnce === 'false') return;
            form.querySelectorAll<HTMLButtonElement>('button[type="submit"]').forEach(btn => {
                btn.disabled = true;
            });
        });
    }
}

const custom = new Custom();